/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Button Controls
import { NgcButtonModule } from '../controls/button/ngc-button.component';

/**
 * NGC Button Module
 */
@NgModule({
    exports: [
        NgcButtonModule
    ]
})
export class NgcButtonsModule {
}